export enum DocumentEndPoint {
  GetList = 'docs/get/',
  GetProgress = 'docs/progress/tbl/get/',
  GetOptions = 'doc/check/',
  CheckById = 'doc/check/id/',
  GetInternal = 'docs/int/get/',
  GetAudit = 'docs/audit/get/',
  Edit = 'doc/edit/',
  SetRegistrationData = 'doc/reg/data/set/',
  GetAvailableControllers = 'docs/controllers/directory/get/',
  GetFiles = 'doc/files/get/',
  GetActiveTypes = 'doc/types/active/get/',
  GetAllTypes = 'doc/types/all/get/',
  GetTypes = 'doc/types/tbl/get/',
  GetMasks = 'system/doc/masks/params/',
  GetTypeParameters = 'doc/types/mask/params/get/',
  GetTypeParameterOptions = 'doc/type/mask/param/values/get/',
  GetTypeParameterOptionHints = 'doc/type/mask/param/values/frequent/',
  Delete = 'doc/delete/',
  Stop = 'doc/stop/',
  SetActivation = 'doc/activation/set/',
  SetRead = 'doc/mark/view/',
  Add = 'doc/add/',
  AddRoute = 'doc/route/add/',
  AddLink = 'doc/link/add/',
  AddLinks = 'doc/links/add/',
  DeleteLink = 'doc/link/delete/',
  Register = 'doc/register/',
  SetController = 'doc/controller/set/',
  SetPreviousController = 'doc/controller/prev/set/',
  SetStartDate = 'doc/startdate/set/',
  UnsetStartDate = 'doc/startdate/unset/',
  GetClients = 'docs/clients/get/',
  GetLinks = 'doc/links/get/',
  GetSignatures = 'doc/files/signatures/get/',
  GetAccess = 'docs/access/get/',
  AddAccess = 'doc/access/add/',
  DeleteAccess = 'doc/access/del/',
  GetComments = 'docs/comments/get/',
  GetGanttItems = 'docs/gantt/items/get/',
  GetReports = 'docs/reports/get/',
  GetReport = 'dashboard/docreport/request/',
  GetStatuses = 'doc/statuses/tbl/get/',
  GetColor = 'docs/color/get/',
  SetColor = 'favorite/my/color/set/',
  UnsetColor = 'favorite/my/color/unset/',
}

export enum ProjectEndPoint {
  GetList = 'projects/get/',
}

export enum UserEndPoint {
  GetId = 'user/id/',
  GetName = 'user/fio/',
  GetList = 'users/get/',
  GetListActive = 'active/users/get/',
  GetRoles = 'current/user/roles/tbl/get/',
}
